import { toast } from "sonner";
import { Share2, Link2, MessageCircle, Facebook } from "lucide-react";

const btn = "inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-[#E5D9C8] text-sm font-semibold text-[#1F2421] hover:bg-[#F3ECE2] transition-colors";

export const ShareButtons = ({ product }) => {
  const shareUrl = `${process.env.REACT_APP_BACKEND_URL}/api/share/product/${product.id}`;
  const text = `${product.name} on AgriNuhse — GH₵ ${Number(product.price).toFixed(2)} per ${product.unit}`;

  const nativeShare = async () => {
    try {
      await navigator.share({ title: product.name, text, url: shareUrl });
    } catch (_) {}
  };
  const copy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    toast.success("Link copied");
  };

  return (
    <div className="mt-6" data-testid="share-buttons">
      <div className="text-xs uppercase tracking-widest text-[#8C6D53] mb-2">Share this listing</div>
      <div className="flex flex-wrap gap-2">
        <a className={btn} href={`https://wa.me/?text=${encodeURIComponent(`${text} ${shareUrl}`)}`} target="_blank" rel="noopener noreferrer" data-testid="share-whatsapp-button">
          <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp
        </a>
        <a className={btn} href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" data-testid="share-facebook-button">
          <Facebook className="w-4 h-4 text-[#1877F2]" /> Facebook
        </a>
        <button type="button" className={btn} onClick={copy} data-testid="share-copy-link-button">
          <Link2 className="w-4 h-4" /> Copy link
        </button>
        {typeof navigator !== "undefined" && navigator.share && (
          <button type="button" className={btn} onClick={nativeShare} data-testid="share-native-button">
            <Share2 className="w-4 h-4" /> More
          </button>
        )}
      </div>
    </div>
  );
};
